// Defensive renderer-safe text helper.
// React throws "Objects are not valid as a React child" when a JS object is
// passed where a string/element is expected. Several backend payloads can
// include nested objects in fields that the UI assumes are strings (e.g.
// audit `actor` = {type, user_id, name}, message-author = {type, name},
// audit `details` = {from, to, reason}, etc.). This helper coerces any
// value to a safe display string.

export function safeText(value, fallback = '') {
  if (value === null || value === undefined) return fallback;
  const t = typeof value;
  if (t === 'string') return value;
  if (t === 'number' || t === 'boolean') return String(value);
  if (Array.isArray(value)) {
    return value.map(v => safeText(v, '')).filter(Boolean).join(', ');
  }
  if (t === 'object') {
    // Prefer human-readable keys when present
    if (value.name) return safeText(value.name, fallback);
    if (value.label) return safeText(value.label, fallback);
    if (value.title) return safeText(value.title, fallback);
    if (value.message) return safeText(value.message, fallback);
    if (value.text) return safeText(value.text, fallback);
    if (value.email) return safeText(value.email, fallback);
    if (value.user_id && value.type) return `${value.type}:${value.user_id}`;
    try { return JSON.stringify(value); } catch { return fallback; }
  }
  return fallback;
}

export default safeText;
